import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf, LogOut, Menu, Coins } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const onLogout = () => {
    logout();
    nav("/");
  };

  const totalCredits =
    user ? (user.credit_balance || 0) + Math.max(0, (user.monthly_credit_quota || 0) - (user.monthly_credits_used || 0)) : 0;

  const navLinks = (
    <>
      <Link to="/library" data-testid="nav-library" className="hover:text-[#C05C42] transition-colors">Library</Link>
      <Link to="/apothecary" data-testid="nav-apothecary" className="hover:text-[#C05C42] transition-colors">Apothecary</Link>
      <Link to="/practitioners" data-testid="nav-practitioners" className="hover:text-[#C05C42] transition-colors">Practitioners</Link>
      <Link to="/contact" data-testid="nav-contact" className="hover:text-[#C05C42] transition-colors">Contact</Link>
      <Link to="/pricing" data-testid="nav-pricing" className="hover:text-[#C05C42] transition-colors">Membership</Link>
      <Link to="/caring-for-country" data-testid="nav-caring-for-country" className="hover:text-[#C05C42] transition-colors">Caring for Country</Link>
      <Link to="/womens-vitality" data-testid="nav-womens-vitality" className="hover:text-[#C05C42] transition-colors">Women's Vitality</Link>
      {user && (
        <>
          <Link to="/dashboard" data-testid="nav-dashboard" className="hover:text-[#C05C42] transition-colors">Dashboard</Link>
          <Link to="/bioage" data-testid="nav-bioage" className="hover:text-[#C05C42] transition-colors">Bio-Age</Link>
          <Link to="/concierge" data-testid="nav-concierge" className="hover:text-[#C05C42] transition-colors">Concierge</Link>
          <Link to="/biomarkers" data-testid="nav-biomarkers" className="hover:text-[#C05C42] transition-colors">Biomarkers</Link>
          <Link to="/microbiome" data-testid="nav-microbiome" className="hover:text-[#C05C42] transition-colors">Microbiome</Link>
          <Link to="/digest" data-testid="nav-digest" className="hover:text-[#C05C42] transition-colors">Digest</Link>
          {user?.is_admin && (
            <Link to="/admin/curate" data-testid="nav-admin" className="hover:text-[#C05C42] transition-colors font-medium text-[#C05C42]">Curate</Link>
          )}
        </>
      )}
    </>
  );

  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-xl bg-[#F9F6F0]/85 border-b border-[#D1C7B8]/60">
      <div className="px-6 sm:px-12 lg:px-20 h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
          <Leaf className="w-5 h-5 text-[#C05C42]" />
          <span className="font-serif text-2xl tracking-tight text-[#2D322B]">Badi</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#2D322B] font-sans">
          {navLinks}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link
                to="/biomarkers"
                data-testid="header-credits"
                title={`${totalCredits} lab extraction credits available`}
                className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-[#5C6359] hover:text-[#C05C42] transition-colors"
              >
                <Coins className="w-3.5 h-3.5 text-[#D49A44]" />
                <span className="tabular-nums">{totalCredits}</span>
              </Link>
              <span className="text-xs text-[#5C6359] uppercase tracking-widest" data-testid="user-name">
                {user.name}
              </span>
              <button onClick={onLogout} data-testid="logout-btn" className="btn-secondary !py-2 !px-4 inline-flex items-center gap-1">
                <LogOut className="w-3.5 h-3.5" /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login" className="text-sm text-[#2D322B] hover:text-[#C05C42] uppercase tracking-widest">Sign in</Link>
              <Link to="/signup" data-testid="header-signup" className="btn-primary !py-2 !px-5">Join</Link>
            </>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          <Menu className="w-6 h-6" />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#D1C7B8]/60 px-6 py-6 flex flex-col gap-4 bg-[#F9F6F0] text-[#2D322B]">
          {navLinks}
          {user ? (
            <button onClick={onLogout} className="btn-secondary !py-2 !px-4 self-start" data-testid="mobile-logout-btn">Sign out</button>
          ) : (
            <div className="flex gap-3">
              <Link to="/login" className="btn-secondary !py-2 !px-4">Sign in</Link>
              <Link to="/signup" className="btn-primary !py-2 !px-4">Join</Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
